
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { triggerFileDownloadByUrl, formatDateToString } from '../../../../../../../helper';
import LoaderCustom from '../../../../../../common/LoaderCustom';


function ContactDetailsView(props) {
    let kys1ContactDetails = props?.supplierDetail?.Data?.KYS1ContactDetails;
    const [showTabLoader, setShowTabLoader] = useState(true);

    useEffect(() => {
        if (props.supplierDetail?.IsSuccessful) {
            setShowTabLoader(false);
        }
    }, [props.supplierDetail?.IsSuccessful])

    const getDomesticOrOverseas = (value) => value === 1 ? "Indian" : "Overseas";
    const getVendorRelation = (value) => value === 1 ? "New" : "Existing";
    return (
        <>
            {showTabLoader && (<LoaderCustom customClass="simulation-Loader hl-loader-fixed" />)}
            <Row>
                <Col xs={12} sm={6} md={6}>
                    <Row>
                        <Col span={12} md={12} xl={12}>
                            <h3 className="sd-common-heading">Company Details</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Supplier Origin</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">
                                <strong>{getDomesticOrOverseas(kys1ContactDetails?.RegistrationDetail?.DomesticandOverseas)}</strong>
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Supplier Relation</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{getVendorRelation(kys1ContactDetails?.RegistrationDetail?.VendorRelation)}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Company Name</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.RegistrationDetail?.CompanyName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Company Type</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.RegistrationDetail?.CompanyTypeName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Supplier Category</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.RegistrationDetail?.VendorCategoryName || '-'}</span>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col span={12} md={12} xl={12}>
                            <h3 className="sd-common-heading">Work Address:
                                <small>
                                    {
                                        kys1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 &&
                                        "(As per GST certificate for Billing)"
                                    }
                                    {
                                        kys1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 2 &&
                                        "(for billing as per Proforma Invoice or commercial invoice)"
                                    }
                                </small>
                            </h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Street</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.Street || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Building/Plot No.</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.House || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Country</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.CountryName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">State/Region</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.StateName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">District</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.District || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">City</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.City || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Postal Code/Zip Code</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.PostalCode || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Contact Number</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.Mobile || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Primary Email Address</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.Email || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Quality Notifications Email</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.NotificationsEmail || '-'}</span>
                        </Col>
                    </Row>

                </Col>
                <Col xs={12} sm={6} md={6}>
                    <Row>
                        <Col span={12} md={12} xl={12}>
                            <h3 className="sd-common-heading">Registered Address</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Street</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorRegisteredAddressDetail?.Street || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Building/Plot No.</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorRegisteredAddressDetail?.House || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Country</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorRegisteredAddressDetail?.CountryName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">State/Region</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorRegisteredAddressDetail?.StateName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">District</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorRegisteredAddressDetail?.District || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">City</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorRegisteredAddressDetail?.City || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Postal Code/Zip Code</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorRegisteredAddressDetail?.PostalCode || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Contact Number</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorRegisteredAddressDetail?.Mobile || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Primary Email Address</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{kys1ContactDetails?.VendorRegisteredAddressDetail?.Email || '-'}</span>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col span={12} md={12} xl={12}>
                            <h3 className="sd-common-heading">Work Address Proof:</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        {
                            kys1ContactDetails?.VendorWorkAddressDetail?.Own && (
                                <>
                                    <Col xs={12} md={6} className="hl-heading-details">
                                        <span className="hl-title-details">Owned</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                                        <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.Own ? "Yes" : "No"}</span>
                                    </Col>

                                    <Col xs={12} md={6} className="hl-heading-details">
                                        <span className="hl-title-details">Proof Type</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                                        <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.ProofTypeName || '-'}</span>
                                    </Col>

                                    <Col xs={12} md={6} className="hl-heading-details">
                                        <span className="hl-title-details">Document</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                                        <span className="hl-desc-details justify-content-between pr-0">
                                            {kys1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocumentName || "-"}
                                            <span>
                                                {
                                                    kys1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocument && (
                                                        <button
                                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4`}
                                                            onClick={(e) => triggerFileDownloadByUrl(e, kys1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocument)}
                                                            title="Download"
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </button>
                                                    )
                                                }
                                            </span>
                                        </span>
                                    </Col>
                                </>
                            )
                        }
                        {
                            kys1ContactDetails?.VendorWorkAddressDetail?.Rented && (
                                <>
                                    <Col xs={12} md={6} className="hl-heading-details">
                                        <span className="hl-title-details">Rented (Rent Agreement)</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                                        <span className="hl-desc-details">{kys1ContactDetails?.VendorWorkAddressDetail?.Rented ? "Yes" : "No"}</span>
                                    </Col>

                                    <Col xs={12} md={6} className="hl-heading-details">
                                        <span className="hl-title-details">Agreement Expiry Date</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                                        <span className="hl-desc-details">{formatDateToString(kys1ContactDetails?.VendorWorkAddressDetail?.AgreementExpiryDate) || "-"}</span>
                                    </Col>

                                    <Col xs={12} md={6} className="hl-heading-details">
                                        <span className="hl-title-details">Document</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                                        <span className="hl-desc-details justify-content-between pr-0">
                                            {kys1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocumentName || '-'}
                                            {
                                                kys1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocument && (
                                                    <button
                                                        className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4`}
                                                        onClick={(e) => triggerFileDownloadByUrl(e, kys1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocument)}
                                                        title="Download"
                                                    >
                                                        <div className="download mr-0"></div>
                                                    </button>
                                                )
                                            }
                                        </span>
                                    </Col>
                                </>
                            )
                        }
                    </Row>
                </Col>
                <Col md="12">
                    <Row className='mt-4'>
                        <Col span={12} md={12} xl={12}>
                            <h3 className="sd-common-heading">Ownership Details</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col md={12} className="hl-heading-details border-0">
                            <span className="d-flex hl-desc-details border-0 pl-0"><strong className="pr-2">No. of Owners:</strong> {kys1ContactDetails?.RegistrationDetail?.NumberOfOwners || '-'}</span>
                        </Col>
                    </Row>
                    <div className="hl-nsa-review-details mt-0">
                        <table className='w-100'>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>City</th>
                                    <th>Country</th>
                                    <th>Date of Birth</th>
                                    <th>Mobile</th>
                                    <th>Email</th>
                                    {
                                        kys1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 && (
                                            <>
                                                <th>Aadhar No.</th>
                                                <th>PAN No.</th>
                                                <th>DIN No.</th>
                                            </>
                                        )
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {kys1ContactDetails?.OwnersShipDetail?.length < 0 ? 'Not Available' : kys1ContactDetails?.OwnersShipDetail?.map(owner => {
                                    return (
                                        <tr>
                                            <td>{owner?.Name || '-'}</td>
                                            <td>{owner?.City || '-'}</td>
                                            <td>{owner?.CountryName || '-'}</td>
                                            <td>{formatDateToString(owner?.DateOfBirth) || '-'}</td>
                                            <td>{owner?.Mobile || '-'}</td>
                                            <td>{owner?.Email || '-'}</td>
                                            {
                                                kys1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 && (
                                                    <>
                                                        <td>{owner?.AadharNo || '-'}</td>
                                                        <td>{owner?.PanNo || '-'}</td>
                                                        <td>{owner?.DinNo || '-'}</td>
                                                    </>
                                                )
                                            }
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default ContactDetailsView